import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const ProfileInfoIcon = ({
  width = 56,
  height = 56,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28"
        cy="28"
        r="26"
        fill="#0D2E68"
        stroke="url(#paint0_linear)"
        strokeWidth="4"
      />
      <path
        d="M28 29.5C31.7266 29.5 34.75 26.4766 34.75 22.75C34.75 
        19.0234 31.7266 16 28 16C24.2734 16 21.25 19.0234 21.25 
        22.75C21.25 26.4766 24.2734 29.5 28 29.5ZM34 31H31.4172C30.3766 
        31.4781 29.2188 31.75 28 31.75C26.7812 31.75 25.6281 31.4781 24.5828 
        31H22C18.6859 31 16 33.6859 16 37V37.75C16 38.9922 17.0078 40 18.25 
        40H37.75C38.9922 40 40 38.9922 40 37.75V37C40 33.6859 37.3141 31 34 31Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="28"
          y1="4"
          x2="28"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.bright_turquoise} />
          <stop offset="1" stopColor="#CEE8FF" />
        </linearGradient>
      </defs>
    </svg>
  </VectorIcon>
);

export default ProfileInfoIcon;
